import React from 'react'

import { Group } from '@/core/api/entities/group'
import { Schedule } from '@/core/api/entities/schedule'
import { useTranslation } from '@/core/i18n/useTranslation'
import ConfirmationModal from '@/shared/components/molecules/ConfirmationModal/ConfirmationModal'

interface RemoveScheduleFromGroupModalProps {
	visible: boolean
	schedule: Schedule | null
	group: Group | null
	onClose: () => void
	onConfirm: () => void
	isRemoving: boolean
}

const RemoveScheduleFromGroupModal: React.FC<
	RemoveScheduleFromGroupModalProps
> = ({ visible, schedule, group, onClose, onConfirm, isRemoving }) => {
	const { t } = useTranslation('common')

	return (
		<ConfirmationModal
			visible={visible}
			title={t('entities.group.remove_schedule.title')}
			description={t('entities.group.remove_schedule.description', {
				scheduleName: schedule?.title,
				groupName: group?.name,
			})}
			confirmText={t('entities.group.remove_schedule.confirm')}
			cancelText={t('actions.cancel')}
			variant="destructive"
			onConfirm={onConfirm}
			onClose={onClose}
			isLoading={isRemoving}
			loadingText={t('actions.loading')}
		/>
	)
}

export default RemoveScheduleFromGroupModal
